import { useEffect } from "react"
import dayjs from "dayjs"

import { StorageKeys } from "types/enums/StorageKeys"

import { getStorageItem } from "utils/localStorage"
import { useRefreshUserProfile } from "hooks/useRefreshUserProfile"

const useUserProfileSync = () => {
  const refreshProfile = useRefreshUserProfile()

  useEffect(() => {
    const interval = setInterval(() => {
      const jsonUserProfile = getStorageItem(StorageKeys.UserProfile)
      if (!jsonUserProfile || typeof jsonUserProfile !== "object") return

      const lastSync = jsonUserProfile.lastSync ? dayjs(jsonUserProfile.lastSync) : dayjs().year(2000)

      if (dayjs().diff(lastSync, "minute") > 30) {
        refreshProfile()
      }
    }, 15000)

    return () => {
      clearInterval(interval)
    }
  }, [refreshProfile])
}

export default useUserProfileSync
